import { apiFetch } from "@/lib/api-client";

export type AuthUser = {
  id: string;
  name: string;
  email: string;
  role: "admin";
};

export type SessionResponse = {
  user: AuthUser;
};

export type LoginInput = {
  email: string;
  password: string;
};

export function login(input: LoginInput) {
  return apiFetch<SessionResponse>("/auth/login", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(input),
  });
}

export function logout() {
  return apiFetch<void>("/auth/logout", {
    method: "POST",
  });
}

export function getSession() {
  return apiFetch<SessionResponse>("/auth/session");
}
